// extracted by mini-css-extract-plugin
module.exports = {"socialNetworksSection":"SocialNetworksSection_socialNetworksSection__92ZOK"};